var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHumanEsg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8777_32687)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 28C8 16.9543 16.9543 8 28 8C39.0457 8 48 16.9543 48 28C48 39.0457 39.0457 48 28 48C16.9543 48 8 39.0457 8 28Z",
    fill: "#F6F3DA"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8777_32687)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.25 28.8333C23.5083 28.8333 22.7833 28.6134 22.1666 28.2013C21.5499 27.7893 21.0693 27.2036 20.7855 26.5184C20.5016 25.8332 20.4274 25.0792 20.5721 24.3517C20.7167 23.6243 21.0739 22.9561 21.5983 22.4317C22.1228 21.9072 22.791 21.5501 23.5184 21.4054C24.2458 21.2607 24.9998 21.335 25.6851 21.6188C26.3703 21.9026 26.956 22.3833 27.368 22.9999C27.7801 23.6166 28 24.3417 28 25.0833C27.9989 26.0776 27.6035 27.0307 26.9004 27.7338C26.1974 28.4368 25.2442 28.8322 24.25 28.8333ZM29.6667 38H18.8333C18.6123 38 18.4004 37.9122 18.2441 37.7559C18.0878 37.5996 18 37.3877 18 37.1667V36.75C18 35.0924 18.6585 33.5027 19.8306 32.3306C21.0027 31.1585 22.5924 30.5 24.25 30.5C25.9076 30.5 27.4973 31.1585 28.6694 32.3306C29.8415 33.5027 30.5 35.0924 30.5 36.75V37.1667C30.5 37.3877 30.4122 37.5996 30.2559 37.7559C30.0996 37.9122 29.8877 38 29.6667 38ZM32.5833 25.5C31.8417 25.5 31.1166 25.2801 30.4999 24.868C29.8833 24.456 29.4026 23.8703 29.1188 23.1851C28.835 22.4998 28.7607 21.7458 28.9054 21.0184C29.0501 20.291 29.4072 19.6228 29.9317 19.0984C30.4561 18.5739 31.1243 18.2168 31.8517 18.0721C32.5792 17.9274 33.3332 18.0016 34.0184 18.2855C34.7036 18.5693 35.2893 19.0499 35.7013 19.6666C36.1134 20.2833 36.3333 21.0083 36.3333 21.75C36.3322 22.7442 35.9368 23.6974 35.2338 24.4004C34.5307 25.1035 33.5776 25.4989 32.5833 25.5ZM31.3992 27.1842C30.623 27.2883 29.8767 27.5516 29.2071 27.9575C28.5374 28.3635 27.9588 28.9034 27.5075 29.5433C29.3749 30.3914 30.8422 31.9285 31.6025 33.8333H37.1667C37.3877 33.8333 37.5996 33.7455 37.7559 33.5893C37.9122 33.433 38 33.221 38 33V32.9683C37.9991 32.1377 37.8211 31.3167 37.4777 30.5604C37.1344 29.804 36.6336 29.1296 36.0088 28.5821C35.3841 28.0347 34.6498 27.6268 33.8549 27.3857C33.0599 27.1447 32.2227 27.0759 31.3992 27.1842Z",
    fill: "#374151"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8777_32687",
    x: 0,
    y: 0,
    width: 56,
    height: 56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.827451 0 0 0 0 0.772549 0 0 0 0 0.282353 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8777_32687"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8777_32687",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8777_32687"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(18 18)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumanEsg);
export default __webpack_public_path__ + "static/media/humanEsg.a290fd584cd077603655b46603ca302b.svg";
export { ForwardRef as ReactComponent };